import de from './de.json'
import en from './en.json'
import nl from './nl.json'

export const TRANSLATIONS = {
  en: {translation: en},
  de: {translation: de},
  nl: {translation: nl},
}
